import { createFileRoute } from "@tanstack/react-router";
import { Einstellungen } from "../features/shell/Einstellungen";

export const Route = createFileRoute("/einstellungen")({
  component: Einstellungen,
});
